export default __webpack_public_path__ + "static/media/greenTick.2987aa6f.svg";